import {tasksList_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/tasksList_template";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";


declare var ko: any;
declare var page: any;

export class tasks extends vnModule_knockoutJS{

    protected tasksList: tasksList_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlListData: XMLHttpRequestHandler;
    protected XHRHdlRescheduleTask: XMLHttpRequestHandler;
    protected XHRHdlSaveRescheduleTask: XMLHttpRequestHandler;
    protected validationsList: validationsList_template;

    //
    // implementation of base class [vnModule]
    protected getModuleName(): string{

        return "tasks";
    }

    //
    // implementation of base class [vnModule]
    public buildContent() : Array<Element>{

        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        this.tasksList = new tasksList_template("tasks", this.viewModel, this)

        return [this.validationsList.build(), this.tasksList.build()];
    }

    // implementation of base class [vnModule]
    public fillPage(): void {

        this.getListFormData();
    }

    //
    // required from template [usersList_template]
    public paginationOnPageClick(): void {

        this.getListData();
    }

    //
    // required from template [accountsList_template]
    protected reorderTasks(): void {

        this.getListData();
    }

    protected getListFormData(): void {

        let subViewModel = this.tasksList.getViewModelForRequest();

        let usrReq_url: string = '/api/tasks/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj): Function {

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    obj.updateFilters(responseParsed);
                    obj.getListData();
                }
            });
        }
    }

    public getListData(): void {

        this.loadingIn(this.tasksList.builtTemplate.querySelector("#list-results-body"));

        if( this.XHRHdlListData ){

            this.XHRHdlListData.cancelAndReset();
        }

        let subViewModel = this.tasksList.getViewModelForRequest();
        //console.log(subViewModel);

        let usrReq_url: string = '/api/tasks/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdlListData = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdlListData.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdlListData.execute();

    }

    /**
     * @param req
     * @param obj
     * @protected
     */
    protected onDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);

                obj.loadingOut(obj.tasksList.builtTemplate.querySelector("#list-results-body"));
            });
        }
    }

    protected updateList(responseParsed: any): void {

        this.tasksList.setPagination(responseParsed.totalCount);
        this.tasksList.setResultPage(responseParsed.totalCount);
        this.tasksList.setTasks(responseParsed.data);
    }

    public filterDropDownOnChange(): number {

        return 1;
    }

    // required from template [tasksList_template]
    protected filterSimpleOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected updateFilters(responseParsed: any): void {

        this.tasksList.setSearchableFields(['operation name', 'taskExecuter name', 'task extraInfo']);
        this.tasksList.setOperationFilterItems(responseParsed.operations);
        this.tasksList.setDatabasesFilterItems(responseParsed.databases);
        this.tasksList.setStatusFilterItems(responseParsed.status);
        this.tasksList.setExecutorGroupFilterItems(responseParsed.executorGroups);
        this.tasksList.setExecutorFilterItems(responseParsed.executors);
        this.tasksList.setUpdateStatuses(responseParsed.updateStatuses);
        this.tasksList.setIdUpdateDelete(responseParsed.idUpdateDelete);
        this.tasksList.setPermissions(responseParsed.permissions);
        this.tasksList.updateGroupSelectedOption(responseParsed.groupSelectedOption);
        this.tasksList.updateOperationSelectedOption(responseParsed.operationSelectedOption);
        this.tasksList.updateExecutorSelectedOption(responseParsed.executorSelectedOption);

    }


    public filterDropdownOnChange(elem): void {

        if (elem != "updateStatuses") {

            this.tasksList.resetPageNumber();
            this.tasksList.resetOrderParameters();
            this.getListFormData();
        }
    }

    public filterSingleGroupSelectorOnChange(elem): void {
        
        this.tasksList.resetPageNumber();
        this.tasksList.resetOrderParameters();
        this.getListFormData();
    }

    

    private resetPageNumber(){
        // go back to page 1 in the pagination
        this.viewModel.tasks.pagination.pageNumber(1);
    }

    public filterSimpleCancel(): void {

    }

    protected deleteTask(task: any): void {

        let formReq_params: Array<Array<string>> = [];

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/tasks/delete/'+task. id , formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onDeleteReturn;
        XHRHdl.execute();
    }

    /**
     * Handles delete response.
     *
     * @param req
     * @param obj
     * @return {function(): void}
     */
    protected onDeleteReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Task deleted successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.validationsList.clearMessages();

                obj.getListData();
            });
        }
    }


    protected rescheduleTask(): void {

        this.loadingIn(this.tasksList.builtTemplate.children.namedItem("timeline"));

        if( this.XHRHdlRescheduleTask ){

            this.XHRHdlRescheduleTask.cancelAndReset();
        }

        let subViewModel = this.tasksList.getViewModelForRequest();

        let usrReq_url: string = '/api/tasks/rescheduleBlocks/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdlRescheduleTask = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdlRescheduleTask.onReadyStateFunction = this.onRescheduleTaskReturn;
        this.XHRHdlRescheduleTask.execute();
    }

    protected onRescheduleTaskReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.tasksList.setTimeline(responseParsed.timeline);
            });

            obj.loadingOut(obj.tasksList.builtTemplate.children.namedItem("timeline"));
        }
    }


    protected saveRescheduleTask(): void {

        this.loadingIn(this.tasksList.builtTemplate.children.namedItem("timeline"));

        if( this.XHRHdlSaveRescheduleTask ){

            this.XHRHdlSaveRescheduleTask.cancelAndReset();
        }

        let subViewModel = this.tasksList.getViewModelForRequest();

        let usrReq_url: string = '/api/tasks/reschedule/save/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdlSaveRescheduleTask = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdlSaveRescheduleTask.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdlSaveRescheduleTask.onReadyStateFunction = this.onSaveRescheduleTaskkReturn;
        this.XHRHdlSaveRescheduleTask.execute();
    }

    protected onSaveRescheduleTaskkReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                //let responseParsed = JSON.parse(req.request.response);
                obj.loadingOut(obj.tasksList.builtTemplate.children.namedItem("timeline"));

                obj.tasksList.onClickCancelReschedule();

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Task rescheduled successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.validationsList.clearMessages();

                obj.getListData();

            });

        }
    }

    protected updateTask(ids, idStatus): void {

        let formReq_params: Array<Array<string>> = [];
        let data = {ids: ids, idStatus: idStatus};

        formReq_params.push(["data", ko.toJSON(data)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/tasks/update/' , formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onUpdateReturn;
        XHRHdl.execute();
    }

    /**
     * Handles delete response.
     *
     * @param req
     * @param obj
     * @return {function(): void}
     */
    protected onUpdateReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Task updated successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.validationsList.clearMessages();

                obj.getListData();
            });
        }
    }

    /**
     * Hook.
     *
     * Redirects to create task page.
     */
    protected addTask(): void{

        page('/tasks/add');
    }

    public autoRefresh(){
        this.getListData();
    }

    public onQuit(){

        this.tasksList.clearRefreshTimeout();
    }
}


// WEBPACK FOOTER //
// ./js/modules/tasks.ts